import { createFileRoute, useParams } from "@tanstack/react-router";
import { EntityTypeFormTab } from "@/features/form-editor/components/entity-type-form-tab";

const ROUTE_ID =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/schema" as const;

export const Route = createFileRoute(ROUTE_ID)({
	component: OrgTicketTypeSchemaTab,
});

function OrgTicketTypeSchemaTab() {
	const { orgId, ticketTypeId } = useParams({ from: ROUTE_ID });
	return (
		<EntityTypeFormTab
			entity="ticket"
			typeId={ticketTypeId}
			scope="org"
			orgId={orgId}
			mutationOrganizationId={orgId}
		/>
	);
}
